var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.recordList),function(item,index){return _c('ax-step',{key:index,attrs:{"data":item,"comment":index===1?_vm.commentsList:[]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }